import React from 'react';

type FormFieldProps = {
  children: React.ReactNode;
};

export function FormField({ children }: FormFieldProps) {
  return <div>{children}</div>;
}
